import http from './http'
console.dir(http)
const forumApi = {
    //——————首页——————
    bannerInfo: (data) => { //轮播/banner/info
        return http.get('/forumapi/banner/info', {
            params: data
        })
    },
    bannerList: (data) => { //banner/page/list列表
        return http.get('/forumapi/banner/page/list', {
            params: data
        })
    },

    getBasic: (data) => { //basicSettings/getBasic详情
        return http.get('/forumapi/basicSettings/getBasic', {
            params: data
        })

    },
    contentInfo: (data) => { ///content/info详情
        return http.get('/forumapi/content/info', {
            params: data
        })
    },
    aboutIntroInfo: (data) => { ///content/info介绍
        return http.get('/forumapi/introduction/info', {
            params: data
        })
    },
    aboutcharacter: (data) => { //character/info人物id
        return http.get('/forumapi/character/info', {
            params: data
        })
    },
    aboutList: (data) => { //character/info人物id
        return http.get('/forumapi/character/page/list', {
            params: data
        })
    },
    newsCategoryPageList: (data) => { //资讯导航列表
        return http.get('/forumapi/news/newsCategory/list', {
            params: data
        })
    },
    newsPageList: (data) => { //资讯分页列表
        return http.get('/forumapi/news/page/list', {
            params: data
        })
    },
    MeetingFirList: (data) => { //cityMeeting/fir/list一级分类列表-----城市会议
        return http.get('/forumapi/cityMeeting/fir/list', {
            params: data
        })
    },
    activityList: (data) => { ///activity/list分页活动   
        return http.get('/forumapi/activity/list', {
            params: data
        })
    },
    ///activityCategory/page/list分页列表
    activityCategory: (data) => {
        return http.get('/forumapi/activityCategory/list', {
            params: data
        })
    },
    projectInfo: (data) => {
        return http.get('/forumapi/activity/info', {
            params: data
        })
    },
    relateActivityList: (data) => {//activity/activityList相关
        return http.get('/forumapi/activity/activityList', {
            params: data
        })
    },
    volunteerInfo: (data) => {//volunteer/info详情
        return http.get('/forumapi/volunteer/info', {
            params: data
        })
    },
    volunApplySave: (data) => {//volunteerApply/save保存
        return http.post('/forumapi/volunteerApply/save', data)
    },
    getCycleApi: (data) => {//activity/cycle获取期
        return http.get('/forumapi/activity/cycle', {
            params: data
        })
    },
    getYearApi: (data) => {//cityMeeting/sec/list二级分类列表
        return http.get('/forumapi/activity/year', {
            params: data
        })
    }, 
    getSecNavList: (data) => {//cityMeeting/sec/list二级分类列表
        return http.get('/forumapi/cityMeeting/sec/list', {
            params: data
        })
    },
    getSecList: (data) => {//cityMeeting/sec/page
        return http.get('/forumapi/cityMeeting/list', {
            params: data
        })
    },
    cityMeetingPage: (data) => {//cityMeeting/page分页列表二级分类分页
        return http.get('/forumapi/cityMeeting/page', {
            params: data
        })
    },
    newsInfo: (data) => {//news/info
        return http.get('/forumapi/news/info', {
            params: data
        })
    },
    relateNew: (data) => {//news/newsList相关
        return http.get('/forumapi/news/newsList', {
            params: data
        })
    },
    uploadApi: (data) => {
        return http.get('/upload/file', {
            params: data
        })
    },
    cityMeetingInfo: (data) => {
        return http.get('/forumapi/cityMeeting/info', {
            params: data
        })
    },
    cityMeetingList: (data) => {
        return http.get('/forumapi/cityMeeting/cityMeetingList', {
            params: data
        })
    },
}

export default forumApi